import { Icon, IconProps } from './Icon';

interface DoesntMatterIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const DoesntMatterIcon = ({ color = '#C2E2FF', gradient, ...props }: DoesntMatterIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 45 45"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      d="M17.031 8.54439C17.031 5.65084 19.3769 3.30494 22.2704 3.30494C25.164 3.30494 27.5099 5.65084 27.5099 8.54439C27.5155 9.93048 28.4494 11.6883 29.8355 11.6883H35.0671C36.681 11.6883 37.9892 12.9966 37.9892 14.6104V19.8421C37.9892 21.2282 36.2314 22.162 34.8453 22.1677C31.9517 22.1677 29.6058 24.5136 29.6058 27.4071C29.6058 30.3007 31.9517 32.6466 34.8453 32.6466C36.2311 32.6522 37.9892 33.5861 37.9892 34.9719V39.1559C37.9892 40.7697 36.681 42.0779 35.0671 42.0779H10.5217C8.90787 42.0779 7.59961 40.7697 7.59961 39.1559V14.6104C7.59961 12.9966 8.90787 11.6883 10.5217 11.6883H14.7056C16.0915 11.6883 17.0253 9.93026 17.031 8.54439Z"
      fill={gradient ? `url(#${gradient.id})` : color}
      style={{
        fill: gradient ? `url(#${gradient.id})` : color,
      }}
    />
  </Icon>
);
